import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-expander-animation',
  imports: [],
  templateUrl: './expander-animation.component.html',
  styleUrls: ['./expander-animation.component.scss'],
})
export class ExpanderAnimationComponent {
  @Input() isExpanded: boolean;
  @Input() id: string;
}
